import { render, staticRenderFns } from "./TriangleSolidIcon.vue?vue&type=template&id=0f6d4600&"
import script from "./TriangleSolidIcon.vue?vue&type=script&lang=js&"
export * from "./TriangleSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports